import axiosInstance from "api/setupAxios";

const uploadApi = {
  getFileUrlApi: async ({ name, type, mimeType, ...reset }) => {
    const { content } = await axiosInstance.post("/tempFile/upload", {
      name,
      type,
      mimeType,
      ...reset,
    });
    return content.data;
  },
};

export default uploadApi;
